import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const TUTORIAL_SECTIONS = [
  {
    id: 'credits_system',
    title: 'tutorial.credits.title',
    icon: 'credit-card',
    steps: 4
  },
  {
    id: 'extra_devices',
    title: 'tutorial.extraDevices.title',
    icon: 'smartphone',
    steps: 4
  }
];

const shouldShowTutorial = (sections, progress) =>
  sections.some(section => !progress[section.id]?.completed);

export const useTutorialStore = create(
  persist(
    (set, get) => ({
      progress: {},
      isTutorialShown: true,

      showTutorial: () => set({ progress: {}, isTutorialShown: false }),

      showTutorialManually: () => set({ isTutorialShown: false }),

      handleCloseTutorial: () => {
        const { progress } = get();
        const allSectionsCompleted = TUTORIAL_SECTIONS.reduce((acc, section) => {
          acc[section.id] = {
            ...progress[section.id],
            completed: true,
            completedAt: new Date().toISOString()
          };
          return acc;
        }, {});
        set({ progress: allSectionsCompleted, isTutorialShown: true });
      },

      markSectionCompleted: (sectionId) => {
        const { progress } = get();
        const newProgress = {
          ...progress,
          [sectionId]: {
            ...progress[sectionId],
            completed: true,
            completedAt: new Date().toISOString()
          }
        };
        set({ progress: newProgress, isTutorialShown: !shouldShowTutorial(TUTORIAL_SECTIONS, newProgress) });
      }
    }),
    {
      name: 'uniplayer_tutorial_sections',
      version: 1,
      migrate: (persistedState, version) => {
        if (version === 0 && persistedState && !persistedState.progress) {
          // Old format: raw progress object stored directly (before Zustand persist)
          const progress = persistedState;
          return {
            progress,
            isTutorialShown: !shouldShowTutorial(TUTORIAL_SECTIONS, progress)
          };
        }
        return persistedState;
      }
    }
  )
);
